var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "container stickHeader bg-grey3 m-0 radius-18 radius-top-0 p-0",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "stickHeader--container d-flex flex-column bg-white shadow-1 radius-18 radius-top-0",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "generalHeader flex-start-center flex-wrap row m-0 px-10 py-10",
              },
              [
                _c("div", { staticClass: "detailsProd" }, [
                  _c("div", { staticClass: "flex-start-center" }, [
                    _c("i", {
                      staticClass:
                        "pl-10 icon-eatselfapp_arrow flipH no-line-height cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.back()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass:
                          "whitespace-nowrap display-2 color-grey1 text-bold",
                      },
                      [
                        _vm.cartItem.qty != 1
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.cartItem.qty) + " x "),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.isUpselling()
                                ? _vm.UpsellService.from_cartItem.product.dn +
                                    " + " +
                                    _vm.cartItem.product.dn
                                : _vm.product.dn
                            ) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "options-nav col-xs-12 col-sm-6 col-md-6 col-lg-6",
                  },
                  [
                    _c("breadcrumbs", {
                      attrs: {
                        list: _vm.categories,
                        current: _vm.currentCategory,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.setCurrent(props.item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(props.item.DefaultName))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "rightFlex col-xs-2 col-sm-3 col-md-3 col-lg-3 flex-end-center",
                  },
                  [
                    _vm.someComposTaken
                      ? _c(
                          "div",
                          { staticClass: "optionsTakenArrowBlock mr-20" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "optionsTakenArrow cursor-pointer hover-opacity",
                                on: {
                                  click: function ($event) {
                                    _vm.hideOptionsTaken = !_vm.hideOptionsTaken
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon-eatselfapp_three-points d-block",
                                  class: {
                                    "rotate90 color-2": !_vm.hideOptionsTaken,
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "priceOrder onStick hidden-xs" }, [
                      _vm.ShopService.shop.canOrder
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btnFlat-color2 flex-1 fsize-18 shadow-1",
                              class: { disabled: !_vm.canOrder },
                              on: {
                                click: function ($event) {
                                  _vm.CartService.checkOrder(_vm.cartItem) &&
                                    _vm.orderItem()
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v("Ajouter")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ShopService.prix(
                                      _vm.CartService.itemTotal(_vm.cartItem)
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("CollapseTransition", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.someComposTaken && !_vm.hideOptionsTaken,
                      expression: "someComposTaken && !hideOptionsTaken",
                    },
                  ],
                  staticClass: "optionsTakenDesc",
                },
                [
                  _c(
                    "div",
                    { staticClass: "container", attrs: { id: "choicesTaken" } },
                    [
                      _c("span", [
                        _c("b", [_vm._v("Vous avez choisi :")]),
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.OptionCategoryService.allItemsTakenDesc(
                                _vm.categoriesCarts
                              )
                            )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "categoryBloc menuSteps" }, [
      _c(
        "div",
        { staticClass: "container" },
        _vm._l(_vm.categories, function (category, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "alignBox menu-category",
              attrs: { id: "menu-category-id-" + category.MenuCategoryId },
            },
            [
              _c("div", { staticClass: "productBloc" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal modalProd optionProd optionMenuCateg",
                    staticStyle: {
                      display: "inline-block",
                      position: "static",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "optionsBloc" },
                      [
                        _c("propose-choice", {
                          attrs: {
                            title: category.DefaultName,
                            "min-choices": category.MinChoicesNumber,
                            "max-choices": category.ChoicesNumber,
                            "num-choices-taken":
                              _vm.sumComposTaken[category.MenuCategoryId],
                          },
                          on: {
                            "skip-choice": function ($event) {
                              return _vm.skipCategory(category.MenuCategoryId)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.ShopService.shop.info.display.itemChildList
                  ? _c(
                      "ul",
                      { staticClass: "row" },
                      _vm._l(
                        category.menuCompos.filter((mc) => mc.product.av),
                        function (finalProduct, i) {
                          return _c("menu-compo-list", {
                            key: i,
                            attrs: {
                              cart: _vm.categoriesCarts[
                                category.MenuCategoryId
                              ],
                              "menu-compo": finalProduct,
                              category: category,
                            },
                            on: {
                              "compo-taken": function ($event) {
                                return _vm.onCompoTakenCb()
                              },
                            },
                          })
                        }
                      ),
                      1
                    )
                  : _c(
                      "ul",
                      { staticClass: "row" },
                      _vm._l(
                        category.menuCompos.filter((mc) => mc.product.av),
                        function (finalProduct, i) {
                          return _c("menu-compo-grid", {
                            key: i,
                            attrs: {
                              cart: _vm.categoriesCarts[
                                category.MenuCategoryId
                              ],
                              "menu-compo": finalProduct,
                              category: category,
                            },
                            on: {
                              "compo-taken": function ($event) {
                                return _vm.onCompoTakenCb()
                              },
                            },
                          })
                        }
                      ),
                      1
                    ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "menuSteps-bottom w-100 bg-white pos-sticky bottom-0 zindex-2 visible-xs-block",
      },
      [
        _c("div", { staticClass: "w-100 flex-center-center flex-wrap p-10" }, [
          _vm.ShopService.shop.canOrder
            ? _c(
                "button",
                {
                  staticClass: "btnFlat-color2 m-10 flex-1 fsize-18 shadow-1",
                  class: { disabled: !_vm.canOrder },
                  on: {
                    click: function ($event) {
                      _vm.CartService.checkOrder(_vm.cartItem) &&
                        _vm.orderItem()
                    },
                  },
                },
                [
                  _c("span", [_vm._v("Ajouter")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ShopService.prix(
                          _vm.CartService.itemTotal(_vm.cartItem)
                        )
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }